module.exports = __webpack_public_path__ + "static/img/h1_x2.f551438.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h1_x2.png
// module id = PeMk
// module chunks = 1